// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2Gmj5","paramInput":"JobSimulator_paramInput__2kxoG","input":"JobSimulator_input__1LT4u"};